export const headers = {
  "X-Master-Key":
    "$2b$10$dhOjSBkhMiuP.UB3.OSUqeoBKs5VaHFoJwNWMBKYi6Nwmgz3iOrG.",
};
